import {AfterViewChecked, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {LegalDocument, LegalService} from '../../../services/legal.service';

/**
 * SCRUM-168: shows the תקנון (company-api/terms/info/). The "accept" button is
 * enabled only after the user scrolled to the end. Closes with `true` when
 * the user accepted, `false`/undefined otherwise.
 */
@Component({
  selector: 'app-terms-consent-dialog',
  standalone: true,
  imports: [MatDialogModule],
  templateUrl: './terms-consent-dialog.component.html',
  styleUrls: ['./terms-consent-dialog.component.css']
})
export class TermsConsentDialogComponent implements OnInit, AfterViewChecked {
  @ViewChild('termsBody') termsBody?: ElementRef<HTMLElement>;

  terms: LegalDocument | null = null;
  loading = true;
  loadError = false;
  readToEnd = false;
  /** 0-100, how far the user has scrolled through the terms. */
  progress = 0;

  constructor(private legalService: LegalService,
              private dialogRef: MatDialogRef<TermsConsentDialogComponent, boolean>) {}

  ngOnInit(): void {
    this.legalService.getTermsConditions().subscribe({
      next: terms => {
        this.terms = terms;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.loadError = true;
      }
    });
  }

  ngAfterViewChecked(): void {
    // Short terms that fit without scrolling count as read.
    const el = this.termsBody?.nativeElement;
    if (el && !this.readToEnd && this.terms && el.scrollHeight <= el.clientHeight + 4) {
      setTimeout(() => { this.readToEnd = true; this.progress = 100; });
    }
  }

  onScroll(): void {
    const el = this.termsBody?.nativeElement;
    if (!el) return;
    const max = el.scrollHeight - el.clientHeight;
    this.progress = max <= 0 ? 100 : Math.min(100, Math.round((el.scrollTop / max) * 100));
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 24) {
      this.readToEnd = true;
      this.progress = 100;
    }
  }

  /** "דלג לסוף": scrolls to the end; the scroll handler then unlocks accept. */
  scrollToEnd(): void {
    const el = this.termsBody?.nativeElement;
    if (!el) return;
    el.scrollTo({top: el.scrollHeight, behavior: 'smooth'});
  }

  accept(): void {
    if (!this.readToEnd) return;
    this.dialogRef.close(true);
  }

  close(): void {
    this.dialogRef.close(false);
  }
}
